<template>
  <DefaultLayoutPublico>
    <v-container fluid class="content-container">
      <SearchBar :staticPosition="true" />
      <!-- Botão de voltar -->
      <v-row>
        <v-col>
          <v-btn
            variant="text"
            class="voltar-btn cursor-pointer"
            @click="voltar"
          >
            <v-icon start class="voltar-icon">mdi-chevron-left</v-icon>
            VOLTAR
          </v-btn>
        </v-col>
      </v-row>

      <!-- chip -->
      <v-row>
        <v-col>
          <v-chip
            v-for="categoria in produto?.categoriasVinculadas || []"
            :key="categoria.id"
            :style="{
              backgroundColor: categoria.tagBackgroundColor,
              color: categoria.tagForegroundColor,
            }"
            class="ma-1 categoria-chip"
            size="default"
            rounded
          >
            {{ categoria.name }}
          </v-chip>
        </v-col>
      </v-row>

      <!-- produto -->
      <v-row>
        <v-col>
          <h1 class="product-title">{{ produto.name }}</h1>
          <hr class="content-hr" />
          <p class="product-description" v-html="productDescription"></p>
        </v-col>
      </v-row>

      <!-- Midia -->
      <div
        v-if="safeVideoUrls.length > 0"
        class="mt-6 midia-container"
      >
        <!-- Renderiza vídeos se existirem -->
        <template v-if="safeVideoUrls.length > 0">
          <v-row
            v-for="(pair, rowIndex) in videoRows"
            :key="`video-row-${rowIndex}`"
            class="midia-row"
            :class="{ 'no-gutters': pair.length === 1 }"
          >
            <v-col
              v-for="(videoUrl, colIndex) in pair"
              :key="`video-${rowIndex}-${colIndex}`"
              cols="12"
              :md="pair.length === 1 ? 12 : 6"
              class="midia-col"
              :class="{
                'pr-md-2': colIndex === 0 && pair.length > 1,
                'pl-md-2': colIndex === 1,
              }"
            >
              <div class="midia-box">
                <iframe
                  class="midia-media"
                  :src="videoUrl"
                  frameborder="0"
                  allowfullscreen
                ></iframe>
              </div>
            </v-col>
          </v-row>
        </template>
      </div>

      <!-- manual -->
      <v-row>
        <v-col>
          <h1 class="manual-title">{{ manual?.title }}</h1>
          <p class="manual-description" v-html="manualDescription"></p>
        </v-col>
      </v-row>

      <!-- Linha separadora antes dos tópicos -->
      <hr v-if="manual?.topics?.length > 0" class="content-hr" />

      <!--topicos dos manuais-->
      <div
        v-for="(topico, index) in topicosVisiveis"
        :key="index"
        class="topic-section"
      >
        <v-row>
          <v-col cols="12">
            <!-- Título do Tópico -->
            <div class="topics-title">
              {{ index + 1 + " - " + topico.title }}
            </div>

            <!-- Mídia do Tópico (Imagem ou Vídeo) -->
            <div v-if="getTopicMediaUrl(topico)" class="topics-midia-box my-4">
              <!-- Verifica se é vídeo -->
              <iframe
                v-if="isVideo(getTopicMediaUrl(topico))"
                class="topics-video"
                :src="formatVideoUrl(getTopicMediaUrl(topico))"
                frameborder="0"
                allowfullscreen
              ></iframe>

              <!-- Caso contrário, exibe imagem -->
              <v-img
                v-else
                class="topics-image"
                :src="`${resourcesUrl}/${getTopicMediaUrl(topico)}`"
                :alt="`Imagem do passo ${topico.title}`"
              />
            </div>

            <!-- Descrição do Tópico -->
            <div class="topics-description" v-html="topico.content"></div>
          </v-col>
        </v-row>
      </div>

      <!-- Linha separadora pós dos tópicos -->
      <hr v-if="topicosVisiveis.length > 0" class="content-hr" />

      <!-- ficha tecnica do manual -->
      <v-row class="manual-ficha-tecnica">
        <v-col>
          <h1 class="manual-ficha-tecnica-title">Ficha Técnica</h1>
          <p class="manual-ficha-tecnica-content">
            Você pode acessar a ficha técnica em nosso site acessando:
            <a
              class="manual-ficha-tecnica-gradient-link"
              href="https://tigre.com.br"
              target="_blank"
              >tigre.com.br</a
            >
          </p>
        </v-col>
      </v-row>

      <!-- rodape do manual -->
      <v-row class="manual-footer">
        <v-col>
          <h1 class="manual-footer-title">{{ manual?.footerTitle }}</h1>
          <p class="manual-footer-content" v-html="manualFooterContent"></p>
        </v-col>
      </v-row>

      <!-- rodape pagina manual -->
      <v-row class="manual-footer-page">
        <v-col>
          <h1 class="manual-footer-page-title">
            <img
              src="../assets/images/tudotigre.png"
              alt="Ícone Tigre"
              class="manual-footer-page-icon-top"
            />
            <span class="gradient-text">Tudo certo, tudo Tigre!</span>
          </h1>
        </v-col>
      </v-row>

      <!-- Card educa tigre -->
      <v-row justify="center">
        <v-col cols="auto">
          <div class="educatige-container">
            <div class="educatige-header-row">
              <img
                src="../assets/images/educatigre.svg"
                alt="EducaTigre"
                class="educatige-full-logo"
              />
              <span class="educatige-description">
                Uma plataforma exclusiva para profissionais de obra.
              </span>
            </div>
            <div class="educatige-inline-row">
              <strong class="educatige-ask">Quer saber mais?</strong>
              <a href="http://educatigre.com/" class="educatige-link"
                >CLIQUE AQUI</a
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </DefaultLayoutPublico>
</template>

<script setup>
import { ref, onMounted, computed, defineProps } from "vue";
import { useRoute, useRouter } from "vue-router";
import DefaultLayoutPublico from "@/layouts/DefaultLayoutPublico.vue";
import { useProduto } from "@/composables/useProduto";
import useProdutos from "@/composables/useProdutos";
import { useManuais } from "@/composables/useManuais";
import { useDisplay } from "vuetify";
import SearchBar from "@/components/SearchBar.vue";

const resourcesUrl = import.meta.env.VITE_RESOURCES_URL || "";
const route = useRoute();
const router = useRouter();
const props = defineProps({
  id: String,
  nome: String,
});
const { mobile } = useDisplay();

const { produto, carregarProduto, atualizarCategoriasVinculadas } =
  useProduto();
const { categorias, categoriasPorId, carregarCategorias } = useProdutos();
const { produtos: todosOsProdutos, carregarProdutos: carregarTodosProdutos } = useProdutos();
const { manual, carregarManual } = useManuais();

const loading = ref(false);

const carregarDados = async () => {
  if (loading.value) return; // evita chamadas duplicadas
  try {
    loading.value = true;    
    let produtoId = route.meta.id; // Tenta obter o ID do meta primeiro

    if (!produtoId) {
      // Se o ID não estiver no meta (ex: acesso direto ou refresh),
      // precisamos encontrar o produto pelo slug.
      const slugDaUrl = route.params.nome;
      if (slugDaUrl) {
        await carregarTodosProdutos(0, 9999, true); // Garante que todos os produtos estão carregados
        const foundProduct = todosOsProdutos.value.find(p => slugify(p.nome) === slugDaUrl);
        if (foundProduct) {
          produtoId = foundProduct.id;
        } else {
          console.error("Produto não encontrado pelo slug:", slugDaUrl);
          router.push({ name: "Home" }); // Redireciona para a home se não encontrar
          return;
        }
      }
    }

    if (!produtoId) {
      console.error("ID do produto não encontrado após todas as tentativas!");
      router.push({ name: "Home" }); // Redireciona para a home se ainda não tiver ID
      return;
    }

    await carregarCategorias();
    await carregarProduto(produtoId);

    if (produto.value) {
      atualizarCategoriasVinculadas(categoriasPorId.value);
      await carregarManual(produtoId);

      // Apenas para desenvolvimento: usar dados mock se a API falhar ou para testes
      if (import.meta.env.DEV && (!produto.value?.id || !manual.value?.id)) {
        console.warn("Usando dados MOCK para produto e manual.");
        // MOCK: Dados fictícios do produto
        produto.value = {
          id: 1,
          name: "Produto Exemplo (MOCK)",
          description: "Descrição fictícia do produto para testes.",
          categoriasVinculadas: [
            {
              id: 10,
              name: "Categoria Teste",
              tagBackgroundColor: "#FFD700",
              tagForegroundColor: "#333",
            },
          ],
          desktopPictureUrl:
            "product-images/desktop_1757359402319_imagemProduto.png",
        };

        // MOCK: Dados fictícios do manual
        manual.value = {
          title: "Manual Exemplo (MOCK)",
          description: "Descrição fictícia do manual.",
          videoTutorialUrl: "https://www.youtube.com/watch?v=JY_jM9-HRM8",
          topics: [
            {
              title: "Passo",
              content: "Conteúdo do passo ",
              desktopPictureUrl:
                "product-images/desktop_1757359402319_imagemProduto.png",
            mobilePictureUrl:"product-images/mobile_1757560766567_22220209_uni_o_sold_vel_iso_1.jpg"
            },
          ],
          footerTitle: "Obrigado por usar o manual (MOCK)",
          footerContent: "Conteúdo do rodapé do manual fictício.",
        };
      }
    }
  } catch (error) {
    console.error("Erro ao carregar produto:", error);
  } finally {
    loading.value = false;
  }
};

onMounted(() => {
  window.scrollTo(0, 0);
  carregarDados();
});

const slugify = (text) => {
  if (!text) return '';
  return text
    .toString() // Converte para string
    .normalize('NFD') // Separa os acentos das letras
    .replace(/[\u0300-\u036f]/g, '') // Remove os acentos
    .toLowerCase() // Converte para minúsculas
    .replace(/\s+/g, '-')           // Substitui espaços por hífens
    .replace(/[^\w-]+/g, '')       // Remove caracteres não-alfanuméricos (exceto hífens)
    .replace(/--+/g, '-')          // Substitui múltiplos - por um único -
    .replace(/^-+/, '')             // Remove - do início
    .replace(/-+$/, '');            // Remove - do fim
};

const voltar = () => {
  router.push({ name: "Home" });
};

const productDescription = computed(() => {
  const texto = produto.value?.description || "";
  return texto;
});

const manualDescription = computed(() => {
  const texto = manual.value?.description || "";
  return texto;
});

const manualFooterContent = computed(() => {
  const texto = manual.value?.footerContent || "";
  return texto;
});

// Função para extrair ID do YouTube de diferentes formatos de URL
const extractYouTubeId = (url) => {
  if (!url) return null;
  
  // Padrões de URL do YouTube suportados:
  // - https://www.youtube.com/watch?v=VIDEO_ID
  // - https://youtu.be/VIDEO_ID  
  // - https://www.youtube.com/shorts/VIDEO_ID
  // - https://www.youtube.com/embed/VIDEO_ID
  // - https://www.youtube.com/v/VIDEO_ID
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/v\/|youtube\.com\/shorts\/)([a-zA-Z0-9_-]{11})/,
    /youtube\.com\/watch\?.*v=([a-zA-Z0-9_-]{11})/
  ];
  
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  return null;
};

const safeVideoUrls = computed(() => {
  if (!manual.value?.videoTutorialUrl) return [];

  const urls = manual.value.videoTutorialUrl.split(";");

  return urls.map((url) => {
    url = url.trim();
    
    // Se não tem protocolo, adiciona https
    if (!url.startsWith("http")) {
      url = "https://" + url;
    }

    // Verifica se é YouTube e extrai o ID
    const youtubeId = extractYouTubeId(url);
    if (youtubeId) {
      return `https://www.youtube.com/embed/${youtubeId}?rel=0&loop=1&playlist=${youtubeId}`;
    }

    // Para outras URLs, retorna como está
    return url;
  });
});

const videoRows = computed(() => {
  const pairs = [];
  for (let i = 0; i < safeVideoUrls.value.length; i += 2) {
    pairs.push(safeVideoUrls.value.slice(i, i + 2));
  }
  return pairs;
});

const isVideo = (url) => {
  if (!url) return false;

  const videoHosts = [
    "youtube.com",
    "youtu.be",
    "vimeo.com",
    "videos.",
    "video",
    ".mp4",
    ".webm",
    ".ogg",
  ];
  return videoHosts.some((host) => url.toLowerCase().includes(host));
};

const formatVideoUrl = (url) => {
  if (!url) return "";
  
  // Se não tem protocolo, adiciona https
  if (!url.startsWith("http")) {
    url = "https://" + url;
  }
  
  // Verifica se é YouTube e extrai o ID
  const youtubeId = extractYouTubeId(url);
  if (youtubeId) {
    return `https://www.youtube.com/embed/${youtubeId}?rel=0&loop=1&playlist=${youtubeId}`;
  }
  
  // Para outras URLs, retorna como está
  return url;
};

const getTopicMediaUrl = (topico) => {
  if (!topico) return "";
  if (mobile.value) {
    return topico.mobilePictureUrl || topico.desktopPictureUrl;
  }
  return topico.desktopPictureUrl || topico.mobilePictureUrl;
};

const topicosVisiveis = computed(() => {
  if (!manual.value?.topics) return [];
  return manual.value.topics.filter((topico) => !topico.disabled);
});
</script>

<style scoped>
.content-container {
  padding: 50px 100px;
}

.cursor-pointer {
  cursor: pointer;
}

.voltar-btn {
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 12px;
  line-height: 100%;
  letter-spacing: 0;
  color: #102954 !important;
  text-transform: none;
  padding-left: 0;
  min-width: 0;
}

.voltar-icon {
  color: #102954 !important;
  font-size: 30px;
}

.categoria-chip {
  font-family: "Ubuntu", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0;
  text-transform: none;
  padding: 4px 12px;
}

.product-title {
  color: #0a4488;
  font-family: "Ubuntu", sans-serif;
  font-weight: bold;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-bottom: 40px;
  margin-top: 20px;
}

.product-description {
  margin-top: 16px;
}

:deep(.product-description p) {
  color: #636463;
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: 0%;
}

.content-hr {
  border: none;
  height: 1px;
  background-color: #cbcccb;
  margin-top: 32px;
  margin-bottom: 32px;
}

.topic-section {
  margin-bottom: 48px;
}

.midia-box {
  width: 100%;
  overflow: hidden;
  height: 500px; 
  background-color: #f4f4f4;
  max-width: 100%;
  border-radius: 12px;
}

.midia-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
  display: block;
}

.product-image {
  aspect-ratio: 3 / 4;
  width: 350px;
  max-width: 100%;
  height: auto;
  object-fit: contain;
  object-position: center;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
  background-color: white;
}

.manual-title {
  font-family: "Ubuntu", sans-serif;
  font-weight: bold;
  font-size: 40px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-bottom: 30px;
  margin-top: 10px;
  background: linear-gradient(90deg, #fb631a, #fc901f);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  display: inline-block;
}

:deep(.manual-description p) {
  color: #636463;
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
}

.manual-footer {
  text-align: center;
}

.manual-footer-title {
  font-family: "Ubuntu", sans-serif;
  font-weight: bold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-top: 10px;
  background: linear-gradient(90deg, #004c97, #0493d4);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  display: inline-block;
}

:deep(.manual-footer-content p) {
  color: #636463;
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
}

.manual-footer-page {
  margin: 24px;
  text-align: center;
}

.manual-footer-page-title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-family: "Ubuntu", sans-serif;
  font-weight: bold;
  font-size: 32px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-top: 10px;
}

.manual-footer-page-icon-top {
  width: 40px;
  height: auto;
}

.gradient-text {
  font-size: 32px;
  background: linear-gradient(90deg, #004c97, #0493d4);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  display: inline-block;
}

.educatige-container {
  background-color: #e1f3fc;
  border-radius: 12px;
  color: #0a4488;
  font-family: "Ubuntu", sans-serif;
  text-align: center;
  padding: 32px;
  display: inline-block;
}

.educatige-description {
  font-weight: bold;
  font-size: 20px;
  text-align: left;
  margin: 0;
  line-height: 1.2;
  max-width: 280px;
}

.educatige-header-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 32px;
  flex-wrap: wrap;
  margin-bottom: 8px;
}

.educatige-ask {
  font-weight: bold;
  font-size: 20px;
  line-height: 1;
  margin: 0;
  padding: 0;
  margin-top: 16px;
  display: block;
}

.educatige-link {
  font-weight: bold;
  font-weight: 700;
  font-size: 20px;
  color: #f37021;
  text-decoration: underline;
  cursor: pointer;
  line-height: 1;
  margin: 0;
  padding: 0;
  display: block;
}

.educatige-inline-row {
  margin: 0;
  padding: 0;
  line-height: 1;
  text-align: center;
}

.educatige-full-logo {
  max-width: 232px;
  height: 48px;
  margin: 0;
}

.topics-title {
  background: linear-gradient(90deg, #004c97, #0493d4);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  text-align: center;
  font-family: "Ubuntu", sans-serif;
  font-weight: bold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
}

.topics-midia-box {
  width: 100%;
  max-width: 780px;
  margin-left: auto;
  margin-right: auto;
}

:deep(.topics-description p) {
  text-align: center;
  color: #636463;
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  font-size: 16px;
  letter-spacing: 0%;
}

.topics-video {
  width: 100%;
  aspect-ratio: 16 / 9;
  border-radius: 12px;
  background-color: black;
  display: block;
}

.topics-image {
  border-radius: 12px;
  aspect-ratio: 16 / 9;
  object-fit: cover;
}

.manual-ficha-tecnica {
  text-align: center;
}

.manual-ficha-tecnica-title {
  font-family: "Ubuntu", sans-serif;
  font-weight: bold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: 0%;
  margin-top: 10px;
  background: linear-gradient(90deg, #004c97, #0493d4);
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
  color: transparent;
  display: inline-block;
}

.manual-ficha-tecnica-content  {
  color: #636463;
  font-family: "Ubuntu", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  letter-spacing: 0%;
}

.manual-ficha-tecnica-gradient-link {
  color: #004c97;;
  text-decoration: none;
  display: inline-block;
  position: relative;
}

@media (max-width: 1200px) {
  .content-container {
    padding: 16px;
  }

  .midia-row {
    flex-wrap: wrap;
  }
  .midia-col {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
</style>
